var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.6 16.6",
    style: {
      enableBackground: "new 0 0 16.6 16.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF9E55;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,1.7C9.4,1,8.9,0.6,8.3,0.6C7.7,0.6,7.2,1,6.8,1.7L0.3,13.2c-0.4,0.7-0.4,1.3-0.1,1.9 c0.3,0.5,0.9,0.8,1.7,0.8h12.8c0.8,0,1.4-0.3,1.7-0.8c0.3-0.5,0.3-1.2-0.1-1.9L9.8,1.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,12.3c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9C9.2,12.7,8.8,12.3,8.3,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,11.3c0.3,0,0.6-0.4,0.6-0.9l0.3-5.6C9.3,4.4,8.9,4,8.4,4H8.2C7.7,4,7.3,4.4,7.4,4.9l0.3,5.6 C7.7,10.9,8,11.3,8.3,11.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.7700ab37d13db3640f270f8bcaad6811.svg";
export { ForwardRef as ReactComponent };